import React, { useEffect, useState, useContext } from "react";
import AppContainer from "../Structure/AppContainer";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import ajaxShiftTemplate from "../../util/remote/ajaxShiftTemplate";
import ajaxShiftAllocation from "../../util/remote/ajaxShiftAllocation";
const ViewShiftAllocation = () => {
  var station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [station_id, setStationID] = useState(station_idd);
  const [shifts, setShifts] = useState([]);
  const [users, setUsers] = useState([]);
  // ===========================
  // Fetch shifts
  const fetchShifts = async () => {
    setLoading(true);
    const res = await ajaxShiftTemplate.list_shit_templates({ station_id });
    if (res.status === "OK") setShifts(res.details);
    else toast.error(res.message);
    setLoading(false);
  };
  // ===========================
  // Fetch users + existing allocations
  const fetchUsers = async () => {
    setLoading(true);
    var data = { station_id: station_id };
    const res = await ajaxShiftAllocation.get_users_with_allocations(data);
    if (res.status === "OK") {
      const { users: apiUsers, allocations } = res.details;
      const mappedUsers = apiUsers.map((u) => ({
        user_id: u.id,
        fullname: u.first_name + " " + u.last_name,
        shift_id: allocations?.[u.id] || null, // set allocated shift or null
      }));
      setUsers(mappedUsers);
    } else {
      toast.error(res.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchShifts();
    fetchUsers();
  }, [station_id]);
  // ===========================
  // Handle allocation change
  const handleShiftChange = (user_id, shift_id) => {
    setUsers((prev) =>
      prev.map((u) =>
        u.user_id === user_id ? { ...u, shift_id: Number(shift_id) } : u
      )
    );
  };
  // ===========================
  // Save all allocations
  const saveAllocations = async () => {
    const payload = users.map((u) => ({
      user_id: u.user_id,
      shift_id: u.shift_id,
    }));
    var data = {
      station_id: station_id,
      allocations: payload,
      allocated_by_id: userId,
    };
    const res = await ajaxShiftAllocation.save_shift_allocations(data);
    if (res.status === "OK") toast.success(res.message);
    else toast.error(res.message);
  };
  return (
    <AppContainer
      title="Shift Allocations"
      previousPageTitle="Dashboard"
      actions={[]}
    >
      <Toaster />
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <div className="table-responsive">
            <table className="table table-bordered text-nowrap">
              <thead>
                <tr>
                  <th>User</th>
                  {shifts.map((s) => (
                    <th key={s.id}>{s.shift_name}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Array.isArray(users) &&
                  users.map((u) => (
                    <tr key={u.user_id}>
                      <td>{u.fullname}</td>
                      {shifts.map((s) => (
                        <td className="text-center" key={s.id}>
                          <input
                            type="radio"
                            name={`shift_${u.user_id}`}
                            checked={Number(u.shift_id) === Number(s.id)}
                            onChange={() => handleShiftChange(u.user_id, s.id)}
                          />
                        </td>
                      ))}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <button className="btn btn-primary mt-3" onClick={saveAllocations}>
            Save All
          </button>
        </>
      )}
    </AppContainer>
  );
};
export default ViewShiftAllocation;
